'use client';

import { FC, SVGProps } from 'react';

const IconGridBreakupHomeHero: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1513" height="140" viewBox="0 0 1513 140" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M252 21.2291H0V0H252V21.2291ZM1260.01 21.2291H1512.01V3.05176e-05H1260.01V21.2291ZM1008 42.4579H1260V21.2288H1008V42.4579ZM1008 63.6881H756H755.999H504V42.459H755.999H756H1008V63.6881ZM1512 97.5211H1512.01V47.7654H1260.01V94.0001H1260V64.0001H1008L1008 90.2234H756H755.999H504L504 94.0001V64.0001H252V47.7655H0V97.5212H0.000411987V140H1512V97.5211ZM252.002 42.4586H504.002V21.2295H252.002V42.4586Z" fill={props['data-fill-color'] ? props['data-fill-color'] : "white"} />
    </svg>
  );
};

export default IconGridBreakupHomeHero;
